var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51075 3.17091C8.8898 1.6097 11.1102 1.6097 11.4893 3.17091C11.7341 4.17932 12.8892 4.65785 13.7754 4.11818C15.1474 3.28221 16.7178 4.85264 15.8818 6.22462C15.3422 7.11086 15.8207 8.26594 16.8291 8.51075C18.3903 8.8898 18.3903 11.1102 16.8291 11.4893C15.8207 11.7341 15.3422 12.8892 15.8818 13.7754C16.7178 15.1474 15.1474 16.7178 13.7754 15.8818C12.8892 15.3422 11.7341 15.8207 11.4893 16.8291C11.1102 18.3903 8.8898 18.3903 8.51075 16.8291C8.26594 15.8207 7.11086 15.3422 6.22462 15.8818C4.85264 16.7178 3.28221 15.1474 4.11818 13.7754C4.65785 12.8892 4.17932 11.7341 3.17091 11.4893C1.6097 11.1102 1.6097 8.8898 3.17091 8.51075C4.17933 8.26594 4.65785 7.11086 4.11818 6.22462C3.28221 4.85264 4.85264 3.28221 6.22462 4.11818C7.11086 4.65785 8.26594 4.17933 8.51075 3.17091ZM10 7.00001C8.34316 7.00001 7.00001 8.34316 7.00001 10C7.00001 11.6569 8.34316 13 10 13C11.6569 13 13 11.6569 13 10C13 8.34316 11.6569 7.00001 10 7.00001Z",
    fill: "#BA0060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsSettings);
export default __webpack_public_path__ + "static/media/notifications-settings.8e19c025559e4b348add5281cafdfb8e.svg";
export { ForwardRef as ReactComponent };